import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import useAuthz from '../../hooks/useAuthz';

const SapStoredRenderer = (props) => {
  const [authz, user, profil] = useAuthz();

  return (
      <>
              <p style={{textAlign: 'center'}}>
                  {props.data.exist ? <span style={{padding: 4, color: 'green', fontWeight: 'bold', fontSize: 14}}><FontAwesomeIcon icon={faCheck} size='lg'/></span> : <span style={{padding: 4, color: 'red', fontWeight: 'bold', fontSize: 14}}><FontAwesomeIcon icon={faTimes} size='lg'/></span>}
              </p>
      </>
  );
};

export default SapStoredRenderer;